import { useEffect, useState } from 'react';
import * as storage from './storage.js';

export const LAST_CALCULATOR_STORAGE_KEY = 'lastCalculatorId';

const listeners = new Set<() => void>();

export function getLastCalculatorId(allowedIds?: readonly string[]): string | undefined {
  const value = storage.get<unknown>(LAST_CALCULATOR_STORAGE_KEY);
  if (typeof value !== 'string' || value.length === 0) return undefined;
  if (allowedIds && !allowedIds.includes(value)) return undefined;
  return value;
}

export function setLastCalculatorId(calculatorId: string, allowedIds?: readonly string[]): void {
  if (allowedIds && !allowedIds.includes(calculatorId)) return;
  storage.set(LAST_CALCULATOR_STORAGE_KEY, calculatorId);
  listeners.forEach((fn) => fn());
}

export function clearLastCalculatorId(): void {
  storage.remove(LAST_CALCULATOR_STORAGE_KEY);
  listeners.forEach((fn) => fn());
}

export function useLastCalculatorId(allowedIds?: readonly string[]): string | undefined {
  const [calculatorId, setCalculatorId] = useState(() => getLastCalculatorId(allowedIds));

  useEffect(() => {
    const listener = () => setCalculatorId(getLastCalculatorId(allowedIds));
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  }, [allowedIds]);

  return calculatorId;
}
